import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { LeftSidebarMode } from './Layout1SettingsChtc'
import { FC, useEffect } from 'react'
import { useSidebarDimensions } from './useSidebarDimensions'
import { isNil } from 'lodash'

interface SidenavToggleBtnProps {
  sidenavToggleRef: React.RefObject<HTMLDivElement>
  layoutSidenavRef: React.RefObject<HTMLDivElement>
  isToggleBtnTouchedRef: React.MutableRefObject<boolean>
  mode: LeftSidebarMode
  updateSidebarMode: (mode: { mode: LeftSidebarMode }) => void
  allowClosing: boolean
}

export const SidenavToggleBtn: FC<SidenavToggleBtnProps> = ({
  sidenavToggleRef,
  layoutSidenavRef,
  isToggleBtnTouchedRef,
  mode,
  updateSidebarMode,
  allowClosing
}) => {
  const isCollapsed = mode === 'close'

  const { getZoomFactor } = useSidebarDimensions()

  const zoomFactor = getZoomFactor()

  useEffect(() => {
    const updateZoomFactor: () => void = () => {
      const zoomFactor = 1 / window.devicePixelRatio
      if (!isNil(sidenavToggleRef.current)) {
        sidenavToggleRef.current.style.transform = `scale(${zoomFactor})`
        sidenavToggleRef.current.style.top = `${310 * zoomFactor}px`
      }
    }
    window.addEventListener('resize', updateZoomFactor)
    return () => {
      window.removeEventListener('resize', updateZoomFactor)
    }
  }, [])

  return (
    <>
      {allowClosing &&
        <div
          ref={sidenavToggleRef}
          onClick={() => {
            isToggleBtnTouchedRef.current = true
            updateSidebarMode(isCollapsed ? { mode: 'full' } : { mode: 'close' })
            if (!isNil(layoutSidenavRef.current)) {
              layoutSidenavRef.current.style.transitionDuration = '0.3s'
            }
          }}
          style={{
            position: 'absolute',
            top: `${310 * zoomFactor}px`,
            left: 0,
            zIndex: 1000,
            display: 'flex',
            width: '25px',
            height: '109px',
            backgroundColor: '#17374F',
            borderTopLeftRadius: '0px',
            borderTopRightRadius: '5px',
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: `${5}px`,
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transform: `scale(${zoomFactor})`,
            transformOrigin: 'top left'

          }}
        >
          {isCollapsed ? <ArrowForwardIosIcon sx={{ color: 'white' }} /> : <ArrowBackIosNewIcon sx={{ color: 'white' }} />}
        </div>}
    </>
  )
}
